import { render, staticRenderFns } from "./WhyGroupTickets.vue?vue&type=template&id=0e97a04d&scoped=true&"
import script from "./WhyGroupTickets.vue?vue&type=script&lang=js&"
export * from "./WhyGroupTickets.vue?vue&type=script&lang=js&"
import style0 from "./WhyGroupTickets.vue?vue&type=style&index=0&id=0e97a04d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97a04d",
  null
  
)

export default component.exports